module.exports = __webpack_public_path__ + "static/media/picture-(166).6ae2e43a.JPG";